import * as ErrorMessages from './errorMessages.js'

const emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const isEmail = (email) => {
  if (email && !emailRe.test(email)) {
    return ErrorMessages.invalidEmail
  }
}

export const required = (text) => (text ? null : ErrorMessages.isRequired)

export const mustMatch = (field, fieldName) => (text, state) =>
  state[field] === text ? null : ErrorMessages.mustMatch(fieldName)

export const minLength = (length, absoluteLength) => (text) =>
  text.length >= length ? null : ErrorMessages.minLength(length, absoluteLength)

export const validDay = (value, state) => {
  const thirtyDays = ['04', '06', '09', '11']
  const thirtyOneDays = ['01', '03', '05', '07', '08', '10', '12']

  if (thirtyDays.includes(state.month) && value > 30) {
    return ErrorMessages.validDate
  } else if (thirtyOneDays.includes(state.month) && value > 31) {
    return ErrorMessages.validDate
  } else if (state.month === '02' && value > 29) {
    return ErrorMessages.validDate
  } else {
    return null
  }
}

export const validYear = (_, state) =>
  state.year < 1900 || state.year > new Date().getFullYear()
    ? ErrorMessages.validDate
    : null

export const justNumbers = (text) => {
  const n = Number(text)
  return isNaN(n) || n < 0 || text === '-0'
    ? ErrorMessages.validNumbers
    : undefined
}

export const satScore = (text) => {
  if (!text) return null

  const n = Number(text)
  if (n < 400 || n > 1600 || n !== Math.round(n)) {
    return ErrorMessages.invalidSAT
  }
  return null
}

export const gpaScore = (text) => {
  if (!text) return null

  const n = Number(text)
  if (n < 0 || n > 4) {
    return ErrorMessages.invalidGPA
  }
  return null
}

export const justStrippedNumbers = (text) => {
  const n = Number(text.replace(/\s+/g, ''))
  return isNaN(n) || n < 0 || text === '-0'
    ? ErrorMessages.validNumbers
    : undefined
}

export const maxLength = (length) => (text) =>
  text.length <= length ? null : ErrorMessages.maxLength(length)

// maxLength but not counting spaces
export const maxStrippedLength = (length) => (text) =>
  text.replace(/\s+/g, '').length <= length
    ? null
    : ErrorMessages.maxLength(length)

export const matchesRegExp = (regex) => (text) =>
  regex.test(text) ? null : ErrorMessages.matchesRegExp

export const isUrl = (text) => {
  try {
    const { protocol = '', pathname = '' } = new URL(text)

    if (pathname.length <= 1 || !/^https?:/.test(protocol)) {
      return ErrorMessages.invalidUrl
    }
  } catch {
    return ErrorMessages.invalidUrl
  }

  return null
}
